import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {PermissionService} from '~local/app/shared/services/PermissionService';
import {DialogService} from '~shared/ng/services/dialog/dialog.service';
import {SimpleModalType} from '~shared/types/dialog.types';


export const canActivatePermission: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const permissionService = inject(PermissionService);
    const dialogService = inject(DialogService);

    if (permissionService.hasPermission(route.data.permission)) {
        return true;
    }

    dialogService.createSimple({
        type: SimpleModalType.ERROR,
        title: 'Permission Error',
        content: 'You don\'t have permission to open this!'
    });

    return router.parseUrl(permissionService.getDefaultRouterLink());
};
